

import {AuwMasonry} from "./AuwMasonry";
import {AuwAjaxPager} from "./AuwAjaxPager";
import {AuwAjaxLoader} from "./AuwAjaxLoader";
import {AuwAjaxFilter} from "./AuwAjaxFilter";

if($('.with-masonry').length) {
    $.each($('.with-masonry'),function(i,e){
        new AuwMasonry($(e));
    });
}


if($('.ajax-pager').length) {
    $.each($('.ajax-pager'),function(i,e){
        new AuwAjaxPager($(e));
    });
}

if($('.ajax-loader').length) {
    $.each($('.ajax-loader'),function(i,e){
        new AuwAjaxLoader($(e));
    });
}

if($('.ajax-filter').length) {
    $.each($('.ajax-filter'),function(i,e){
        new AuwAjaxFilter($(e));
    });
}
